import type { RankingStaticContent } from '@core-api/presentation/types/response';
import type { RankingT } from '@mentimeter/question-modules-types';
import { usePresentationContext } from '../../legacy-context/presentationContext';
import { RankingPresentation } from './RankingPresentation';

export function RankingPresentationDataHandler() {
  const { useQuestion, InteractiveCanvasComponents, useConfig, useResults } =
    usePresentationContext();
  const { enableAnimations } = useConfig();
  const { results = [] } = useResults<RankingT>();
  const slide = useQuestion();
  const staticContent = slide.staticContent as RankingStaticContent;
  const interactiveContent = slide.interactiveContents[0]!;

  const choices = interactiveContent.choices.map((choice, index) => ({
    id: choice.legacyChoiceId ?? index + 1,
    label: choice.title,
  }));

  return (
    <RankingPresentation
      title={slide.title}
      styledTitle={staticContent.styledTitle as Record<string, unknown>}
      label={staticContent.label}
      longerDescription={interactiveContent.description}
      fontSizeOffset={staticContent.textSizeOffset}
      choices={choices}
      shouldAnimate={enableAnimations}
      shouldHideResults={slide.responseVisibility === 'hidden'}
      results={results}
      CanvasVisualizationArea={
        InteractiveCanvasComponents?.CanvasVisualizationArea
      }
    />
  );
}
